<template>
    <div id="schedule-page">
        <div class="page-heading hide-on-small">
            <h2 class="display-4 montserrat-bold mb-0">Business Hours</h2>
            <div class="mt--2 heading-small">Shop's regular operation hours</div>
        </div>

        

        <div class="bg-white shadow-reg list-container card-list-container">
            <!-- <div class="table-navbar">
                <a :class="['table-navbar-item', isStatusActive('all') && 'active']" href="/all" @click.prevent="setStatusFilter('all')">Business Hours</a>
            </div> -->
            <div class="container-fluid" style="border-top: 1px solid rgba(0, 0, 0, 0.1);">
            <!-- Content -->
                <template v-if="isRequesting">
                    <h3 class="text-muted m-0 pt-5 pb-5 text-center"><i class="fas fa-spin fa-spinner mr-2"></i> Loading schedules </h3>
                </template>
                <template v-else>
                    <operation-item v-for="(schedule, key) in schedules" :key="key" :schedule="schedule" />
                </template>
            </div>
        </div>

    </div>
</template>

<script>
import { route, get } from "@utils/network";
import OperationItem from "./partials/OperationItem";
// import AddressSection from "./partials/AddressSection";

export default {
    name: "SchedulePage",
    components: {
        OperationItem,
    },

    data: () => ({
        isRequesting: true,
        shop: {},
        schedules: {},
    }),

    methods: {
        initialize(shop) {
            this.shop = shop;
            this.fetchSchedules();
        },

        fetchSchedules() {
            this.isRequesting = true;
            get(route("shops/:id/operations", {id:this.shop.id}))
                .then(response => this.schedules = response.data.result.schedules)
                .catch(error => {
                    console.log(error);
                    this.promptErrors(error.response.data.message);
                })
                .finally(() => this.isRequesting = false);
        }
    },

    mounted() {
        this.$emit("mounted");
    }
}
</script>

<style lang="css" scoped>
    .page-heading {
        margin-bottom: 15px;
        padding: 0px 24px;
    }
</style>